////////////////////////////////////////////////////
// this function holds the playlist data!
const getPlaylistData = () => {

  // data array
  const data = [

    // Kristoffer Ørum
    {
      title: 'Dorothy R. Santos, Executive Director of Processing Foundation &mdash; Why Code?',
      contributor: "Winnie Soon",
      thumb: "DSantos.jpg",
      file: 'PCDcast_DSantos-001',
      // file: 'PCDcast_DSantos',
      peakfile: 'DSantos.png',
      desc: "Why does <a href='https://dorothysantos.com/' target='_blank'>Dorothy</a> want to engage with the coding scene even though she is not a programmer? What can we learn from Processing Foundation about building a local coding community in Aarhus? How do we make space and create a safe space for others? Dorothy R. Santos, a Filipina American writer, artist, and educator, shares her experience to artist-educator <a href='http://siusoon.net/' target='_blank'>Winnie Soon</a>, a member of the <a href='https://codeandshare.net/' target='_blank'>Code&Share[ ] community</a>",
      duration: "28:16",
      rss: "rssfeed",
      howl: null
    },    

    // Kristoffer Ørum
    {
      title: 'A Conversation with Artist Kristoffer Ørum',
      contributor: "Anders Visti",
      thumb: "KØrum.jpg",
      file: 'PCDcast_Kristoffer',
      peakfile: 'Kristoffer.png',
      desc: "This is a conversation with Copenhagen based artist and educator <a href='https://oerum.org/' target='_blank'>Kristoffer Ørum</a>. Kristoffer will be performing at the upcoming Processing Community Day in Aarhus, in a giant crayfish costume(!). The conversation revolves around kin-making, art production, community building, fiction and fabulation, teaching, music, internet and explorative code practices. The conversation partner is artist and coder <a href='https://andersvisti.dk/' target='_blank'>Anders Visti</a>",
      // desc: "This is a conversation with Copenhagen based artist Kristoffer Ørum. He will be performing at the upcoming Processing Community Day in Aarhus as a giant crayfish(!). I asked him if it's fair to say that almost all of his works are kin-making, in the sense that they speculate on technological and biological systems and networks -and I also wanted to know if the present day internet has changed how he perceives and works with fiction and fabulation in his own work",
      duration: "31:54",
      rss: "rssfeed",
      howl: null
    },

  ];

  return data;
};

export {
  getPlaylistData
}